//Needed for Module federation to work
//Fixes "Shared module is not available for eager consumption" by loading the modules in correct order
import('./index');
